/**
 * Calculate the reading time for a rich text
 * @param {string} incomingText
 */
export const useWordCounter = (incomingText) => {
  /** Cleaning eventually rich-text */
  const text = incomingText.replace(/<\/?[^>]+(>|$)/g, '');
  /** Number of word per minute */
  const wordsPerMinute = 200;
  /** Counting the number of word in the w */
  const textLength = text.split(' ').length;
  if (textLength > 0) {
    return Math.ceil(textLength / wordsPerMinute);
  }
  return 1;
};
